import { Icon } from "@chakra-ui/react"
const DeviceIcon = () => {
    return (
        <>
            <Icon
                width="4"
                height="4"
                viewBox="0 0 16 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M0 2.75C0 1.2332 1.2332 0 2.75 0H12.375C13.8918 0 15.125 1.2332 15.125 2.75V19.25C15.125 20.7668 13.8918 22 12.375 22H2.75C1.2332 22 0 20.7668 0 19.25V2.75ZM8.9375 19.25C8.9375 18.8853 8.79263 18.5356 8.53477 18.2777C8.27691 18.0199 7.92717 17.875 7.5625 17.875C7.19783 17.875 6.84809 18.0199 6.59023 18.2777C6.33237 18.5356 6.1875 18.8853 6.1875 19.25C6.1875 19.6147 6.33237 19.9644 6.59023 20.2223C6.84809 20.4801 7.19783 20.625 7.5625 20.625C7.92717 20.625 8.27691 20.4801 8.53477 20.2223C8.79263 19.9644 8.9375 19.6147 8.9375 19.25ZM12.375 2.75H2.75V16.5H12.375V2.75Z" fill="white" />
            </Icon>
        </>
    )
}
export default DeviceIcon;
